export const SET_NEW_TRANSACTIONS = 'SET_NEW_TRANSACTIONS';
export const UPDATE_NEW_TRANSACTIONS = 'UPDATE_NEW_TRANSACTIONS';
export const SET_LAST_TRANSACTION = 'SET_LAST_TRANSACTION';
export const MARK_ACCOUNT_READ = 'MARK_ACCOUNT_READ';
export const LOAD_ACCOUNTS = 'LOAD_ACCOUNTS';
export const UPDATE_ACCOUNT = 'UPDATE_ACCOUNT';
export const LOAD_CATEGORIES = 'LOAD_CATEGORIES';
export const LOAD_COMMON_PAYEES = 'LOAD_COMMON_PAYEES';
export const LOAD_PAYEES = 'LOAD_PAYEES';
export const SET_PREFS = 'SET_PREFS';
export const MERGE_LOCAL_PREFS = 'MERGE_LOCAL_PREFS';
export const MERGE_GLOBAL_PREFS = 'MERGE_GLOBAL_PREFS';
export const MERGE_SYNCED_PREFS = 'MERGE_SYNCED_PREFS';
export const SET_BUDGETS = 'SET_BUDGETS';
export const SET_REMOTE_FILES = 'SET_REMOTE_FILES';
export const SET_ALL_FILES = 'SET_ALL_FILES';
export const CLOSE_BUDGET = 'CLOSE_BUDGET';
export const SET_APP_STATE = 'SET_APP_STATE';
export const PUSH_MODAL = 'PUSH_MODAL';
export const REPLACE_MODAL = 'REPLACE_MODAL';
export const CLOSE_MODAL = 'CLOSE_MODAL';
export const COLLAPSE_MODALS = 'COLLAPSE_MODALS';
export const POP_MODAL = 'POP_MODAL';
export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';
export const SET_NOTIFICATION_INSET = 'SET_NOTIFICATION_INSET';
export const GET_USER_DATA = 'GET_USER_DATA';
export const SET_LAST_UNDO_STATE = 'SET_LAST_UNDO_STATE';
export const SET_LAST_SPLIT_STATE = 'SET_LAST_SPLIT_STATE';
export const SET_ACCOUNTS_SYNCING = 'SET_ACCOUNTS_SYNCING';
export const ACCOUNT_SYNC_STATUS = 'ACCOUNT_SYNC_STATUS';
export const SIGN_OUT = 'SIGN_OUT';
export const INVITE_TO_SHARE_SUCCESS = 'INVITE_TO_SHARE_SUCCESS';
export const INVITE_TO_SHARE_FAILURE = 'INVITE_TO_SHARE_FAILURE';
export const INVITE_TO_SHARE_RESET = 'INVITE_TO_SHARE_RESET';
